export default __webpack_public_path__ + "static/media/project2_mockup.bfbe536d.png";